import { ref } from "vue";
import { useStore } from "@/store";
const store = useStore();
const activeRowModal: any = ref({ data: null });
import { GeneralActionTypes } from "@/store/modules/general/action-types";
import i18n from '@/localization/i18n';
const { t } = i18n.global;

function getRegistryHiveById(value: number): string | undefined {
  const registryHives = store.state.general.enums?.['RegistryHive'] || [];
  const item = registryHives.find((x: any) => x.value === value);
  return item?.label;
}

function getAppliesToById(value: number | string): string | undefined {
  const options = store.state.general.enums?.['AppliesTo'] || [];
  const item = options.find((x: any) => String(x.value) === String(value)); 
  return item?.label;
}

function getAccessControlById(value: number): string | undefined {
  const accessControlOptions = store.state.general.enums?.['GlobalAccessControl'] || [];
  const item = accessControlOptions.find((x: any) => x.value === value);
  return item?.label;
}
function getAccessControlStyle(value: number) {
    const label = (getAccessControlById(value) || '').toLowerCase();

    let color = '#1677FF';
    let bg = '#1677FF33';

    if (label.includes('deny') || label.includes('block')) {
        color = '#E04C4D';
        bg = '#DE323229';
    } else if (label.includes('read/write')) {
        color = '#0C7EC5';
        bg = '#01AAF342';
    } else if (label.includes('read only')) {
        color = '#3461D3';
        bg = '#D3E0FF';
    }

    return { color, bg };
}

const data = {
    filter: {
        title: "registryAccessfilter",
        pageName: "registryAccessfilter",
        genre: "registryAccessPageFilter",
        ignoreSaveFilter: true,
        noDateSelect: true,
        hideFilter: false,
        //quickSearch: "fullTextSearch",
        filters: [
        ],
    },
    header: {
        navigation: [

        ],
        buttonPosition: "pr-4 justify-content-between",
        buttons: [

        ],
    },
    component: {
        type: "ag-table",
        options: {
            columns: [
                {
                    label: () => t('registryKey').toUpperCase(),
                    field: "registryKey",
                    sortable: true,
                    jsSort: true,
                    display: (row: any) => {
                        const truncateMiddle = (input: string, max = 50): string => {
                            const str = (input || "").toString();
                            if (str.length <= max) return str;
                            return str.slice(0, max) + "...";
                        };
                        let registryHive = null;
                        const registryKey = row.registryKey || "";
                        if (row.registryHive) {
                            registryHive = getRegistryHiveById(row.registryHive);
                        }
                        const hiveLabel = String(registryHive || '');
                        const lower = hiveLabel.toLowerCase();
                        let iconClass = 'ag-icon_hkey_local_machine';
                        if (lower.includes('current') && lower.includes('user') && lower.includes('classes')) {
                            iconClass = 'ag-icon_hkey_current_user_classes';
                        } else if (lower.includes('current') && lower.includes('user')) {
                            iconClass = 'ag-icon_hkey_current_user';
                        } else if (lower.includes('users')) {
                            iconClass = 'ag-icon_hkey_users';
                        } else if (lower.includes('local') && lower.includes('machine')) {
                            iconClass = 'ag-icon_hkey_local_machine';
                        }else if (lower.includes('current') && lower.includes('config')) {
                            iconClass = 'ag-icon_hkey_current_config';
                        }else if (lower.includes('classes') && lower.includes('root')) {
                            iconClass = 'ag-icon_hkey_classes_root';
                        }
                        const truncatedRegistryKey = truncateMiddle(registryKey, 50);
                        let html = "<div class='d-flex flex-column align-items-start'>";
                        html += `<div class='d-flex align-items-center'><i class='ag-icon ${iconClass}' style='width:16px;height:16px;margin-right:8px;'></i><span style='color: #01172F; font-weight: bold;'>${hiveLabel}</span></div>`;
                        html += "<span style='color: #01172F; margin-left:24px' >" + truncatedRegistryKey + "</span>";
                        if (row.enabled === false) {
                            html += "<div class='d-flex align-items-center' style='margin-top:10px; margin-left:24px'><i class='ag-icon ag-icon_warning_filled' style='font-size:0.8em !important;'></i><span style='font-size:0.7em; color:#636363;'>This rule is disabled and will not be published</span></div>";
                        }
                        html += "</div>";
                        return html;
                    },
                    width: "40%",
                },
                {
                    label: () => t('registryValue').toUpperCase(),
                    field: "registryValue",
                    sortable: true,
                    jsSort: true,
                    display: (row: any) => {
                        const registryValue = row.registryValue ?? "";
                        return `<span style='color: #01172F;'>${registryValue}</span>`;
                    },
                    width: "10%",
                },
                {
                    label: () => t('accessControl').toUpperCase(),
                    field: "accessControl",
                    display: (row: any) => {
                        const accessControl =row.accessControl ? getAccessControlById(row.accessControl) : "";
                        const styles = row.accessControl != null ? getAccessControlStyle(row.accessControl) : { color: '#1677FF', bg: '#1677FF33' };
                        return `
                            <span style='margin-left:8px;background:${styles.bg};color:${styles.color};border-radius:16px;padding:2px 8px;font-weight:700;font-size:12px;display:inline-flex;align-items:center;'>
                                ${accessControl}
                            </span>`;
                    },
                    sortable: true,
                    jsSort: true,
                    width: "15%",
                },
                {
                    label: () => t('appliesTo').toUpperCase(),
                    field: "appliesTo",
                    display: (row: any) => {
                        const appliesTo =row.appliesTo ? getAppliesToById(row.appliesTo) : "";
                        return `<span style='color: #01172F;'>${appliesTo}</span>`;
                    },
                    sortable: true,
                    jsSort: true,
                    width: "15%",
                },
                {
                    label: () => t('action').toUpperCase(),
                    field: "commands",
                    justify: 'justify-content-center',
                    style: { justifyItems: 'center' },
                    components: [
                        {
                            component: "appGroupTableEditComponent",
                        },
                        {
                            component: "copyAction",
                            class: "mr-2 ml-2",
                        },
                        {
                            component: "appGroupDeleteComponent",
                        },
                    ],
                    width: "120px",

                },
            ],
            rows: [],
            total: 0,
            sortable: {
                order: "",
                sort: "asc",
            },
            page: 0,
            pageSize: 0,
            isLoading: true,
            showPagination:false,
            dateFilter: false,
            zebra: true,
            separateBorders: true,
            editOnRowClick: true,
            fetchTable: (options: any) => {
                store.dispatch(GeneralActionTypes.GET_GLOBAL_POLICY_REGISTRY_ACCESS, {
                    options: options,
                    filters: {}
                });
            }
        },
    },

};

export default data;
